import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const HearthFailureIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M17.2 14.3l-2.4 2.3c-.1.1-.3.2-.5.2s-.4-.1-.5-.3L10 11.4 7 14c-.1.1-.3.2-.5.2H2.7c.7 1 1.4 1.9 2.2 2.8 2 2.1 4.3 4 6.7 5.6.1.1.3.1.4.1.2 0 .3 0 .4-.1 3.3-2.3 6.2-5.1 8.7-8.2l-3.9-.1z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M1.7 12.8h4.5l3.3-3c.2-.1.4-.2.6-.2.2 0 .4.1.5.3l3.8 5.1 2-1.9c.1-.1.3-.2.5-.2H22c.6-1 1-2.2 1.2-3.4.2-2-.4-4-1.7-5.5-2.2-2.5-6-2.6-8.5-.4-.5.5-.9 1-1.3 1.6-1-1.9-3-3.1-5.2-3.1-1.5 0-2.9.6-4 1.6C1.3 5.1.6 6.9.7 8.8c.1.9.2 1.7.4 2.5l.6 1.5"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default HearthFailureIcon;
